import React, { useEffect, useRef, useState } from 'react'
import Footer from '../common/Footer'
import Header from '../common/Header'
import { Link } from 'react-router-dom'
import postauthorname from "../../images/testimonialsuser.png";
import stockmarketpost01 from "../../images/stock-market-img01.png";
import stockmarketpost02 from "../../images/stock-market-img02.png";
import stockmarketpost03 from "../../images/stock-market-img03.png";
 const Blogdetals = () => {

   let base_image_url = process.env.REACT_APP_IMAGE_URL;
    const [langcode, setLangcode] = useState(
      JSON.parse(localStorage.getItem("langcode")) || {
        Code: "en",
        Name: "English",
      }
    );
  
    function useMediaQuery(query) {
      const [matches, setMatches] = useState(false);
      useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = e => setMatches(e.matches);
        mql.addEventListener('change', handler);
        setMatches(mql.matches);
        return () => mql.removeEventListener('change', handler);
      }, [query]);
      return matches;
    }
  
    const isDesktop = useMediaQuery('(min-width: 1402px)');
    const wrapperRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [aboutpagedata, setAboutpagedata] = useState();
    useEffect(() => {
      if (!isDesktop) return;
      const handleScroll = () => {
        setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
      };
  
      const handleResize = () => {
        if (wrapperRef.current) {
          document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
        }
      };
  
      // Initial setup
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
        document.body.style.overflow = "auto";
  
        wrapperRef.current.style.transition = "transform 0.3s ease-out";
        wrapperRef.current.style.position = "fixed";
        wrapperRef.current.style.top = "0";
        wrapperRef.current.style.left = "0";
        wrapperRef.current.style.width = "100%";
        wrapperRef.current.style.padding = "0";
        wrapperRef.current.style.zIndex = "2";
        wrapperRef.current.style.display = "block";
        wrapperRef.current.style.backfaceVisibility = "hidden";
      }
  
      // Add scroll and resize listeners
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);
  
      // Cleanup on component unmount
      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      };
    }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  
    // Apply scroll effect to the wrapper
    useEffect(() => {
      if (wrapperRef.current) {
        wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
      }
    }, [scrollTop]);
    useEffect(() => {
      document.body.style.backgroundColor = "#000000";
      return () => {
        document.body.style = {};
      };
    }, []);
    useEffect(() => {
      const handleStorageChange = () => {
        const newLangcode = localStorage.getItem("langcode");
        setLangcode(JSON.parse(newLangcode)); // Update the state when langcode changes
      };
  
      window.addEventListener("storage", handleStorageChange);
  
      // Cleanup listener on component unmount
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }, []);

  return (
    <div className="home">
      <div className="main-page" ref={wrapperRef}>
        <Header />
          
        <section className="blogMainSec">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-4">
                <div className="post-breadcrumbs-list">
                  <Link to="">Equlix blog</Link> / 
                  <Link to="">Knowledge base</Link> / 
                  <span>Trading</span>
                </div>

                <h1 className="blogdetal-title text-white mb-0">Knowledge base</h1>
              </div>

              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost01} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost02} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost03} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost01} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost02} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 py-3">
                <div className="blog_item_card">
                  <img className="post-card-picture" src={stockmarketpost03} alt="" />
                  <Link to="" className="post-link-a">
                    <div className="post-category">Trading platforms</div>
                    <div className="post-meta">
                      <div className="post-meta-date">18 August 2025</div>
                      <div className="post-meta-read-time"><i class="fa-regular fa-clock"></i> 22 min to read</div>
                    </div>
                    <div className="post-author-dt">
                      <img src={postauthorname} alt="" />
                      <span className="post-author-name">Carolina Silva</span>
                    </div>
                    <div className="post-info">
                      <h4 className="post-title">Day Trading Simulator No Login: Instant Access Trading Practice Platforms</h4>
                      <div className="post-overlay-text">
                        Mastering Day Trading Without Risk Day trading is fast-paced and high-risk, requiring skill and discipline. Simulators let traders practice in realistic market conditions without financial loss.
                      </div>
                    </div>
                    <div className="post-default-actions">
                      <div className="post-default-actions-item"><i class="fa-regular fa-eye"></i> 102,213</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-message"></i> 0</div>
                      <div className="post-default-actions-item"><i class="fa-regular fa-thumbs-up"></i> 0</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  )
}
export default Blogdetals